export default "<div class=\"container not-found-wrapper\">\n  Not found.\n</div>\n"